import get from 'lodash/get';

const NOT_FOUND_CODE = 404;

export default function isNotFound(e: unknown) {
  return get(e, 'response.status') === NOT_FOUND_CODE;
}
